import { AbstractControl, Validators } from "@angular/forms"
import { UserPortfolioPreferencesService } from "../services/user-preferences/user-portfolio-preferences.service";

export function getValidatorConfig(id: string, userValidator: UserPortfolioPreferencesService) {
  return {
    portFolioName: [Validators.required, Validators.minLength(4), userValidator.noDefaultPortfolio]
  }[id];
}

export function isValidPortfolioName(control: AbstractControl): boolean {
  const { errors, touched, dirty } = control;
  if (!errors || !(touched || dirty)) return false;
  return !!(errors['minlength'] || errors['noDefaultPortfolio']);
}

export function isUrlValid(string) { try { new URL(string); return true; } catch (err) { return false; } }

export function sanitizeUrl(url: string): string {
  if (!url || url === "false") {
    return null;
  }

  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    url = `http://${url}`;
  }

  return isUrlValid(url) ? url : null;
}
